import React from 'react';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import { Grid, Row, Col } from 'components/Grid';
import style from '../EnterCarDetailsPage/style.scss';
import EnterUserDetailsForm from 'components/EnterUserDetailsForm';
import { Ads, Banner, Mpu, Overlay, Overlay2 } from 'components/Ads';

export default class EnterUserDetailsPage extends React.Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired
  };

  render() {
    const { history } = this.props;
    return (
      <Ads>
        <MetaTags>
          <title>Free Car Valuation - How much is my car worth?</title>
        </MetaTags>
        <div className={style.bannerAd}>
          <Banner id="gpt_7294_masthead1" adUnitLevel3="yourdetails" />
        </div>
        <div className={style.pageContent}>
          <Grid className={style.grid}>
            <Row>
              <Col colLg={8} colMd={7} colXs={12}>
                <div className={style.breadcrumb}>
                  <a href="https://www.whatcar.com">Home</a> &gt; Car valuations
                </div>
                <h1 className={style.mainHeading}>Free car valuation</h1>
                <div className={style.formContainer}>
                  <EnterUserDetailsForm history={history} />
                </div>
              </Col>
              <Col colLg={4} colMd={5} colXs={12}>
                <div className={style.rail}>
                  <Mpu id="gpt_7294_mpu_flexible1" adUnitLevel3="yourdetails" />
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
        <Overlay id="gpt_7294_overlay" adUnitLevel3="yourdetails" />
        <Overlay2 id="gpt_7294_overlay2" adUnitLevel3="yourdetails" />
      </Ads>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EnterUserDetailsPage/EnterUserDetailsPage.js